import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions.ts";
import {uniqueUuid} from "@vesta/unique/unique.ts";

export function getListOfOrganizationsWithDashboard(environment: string): Uuid[] | null {
    if (environment.trim().toLocaleLowerCase() === "prod") {
        return [
            uniqueUuid`f1129bb9-7efb-4bf9-98e4-85f43d32ea0c`,
            uniqueUuid`95f9667d-4398-4a88-9717-e365fd1218be`,
            uniqueUuid`a91ec34f-e3c3-49f6-9a2f-cd176fd6f68d`,
            uniqueUuid`e8cca45a-8a1f-443d-b77f-2dd71a9fe18d`,
            uniqueUuid`d5b65ef8-7640-4673-9ecb-c0259fd0178f`,
            uniqueUuid`27b4be02-8310-4f62-b2b7-77742b4d5114`,
            uniqueUuid`383cc3c8-5d3b-41db-9e31-850119ce414a`,
            uniqueUuid`5dc74fd9-5d5a-4e96-a8fa-817aac8df111`,
            uniqueUuid`593d699d-27f4-4ea5-a4af-a780e438397e`,
            uniqueUuid`7c2e2459-f264-48c4-875d-aa1b80e6c907`,
            uniqueUuid`fc457579-2301-4663-a41c-4bc1cb2fa88c`,
            uniqueUuid`f93a7e4f-ba9e-4c01-b772-ac8852cbd756`,
            uniqueUuid`53d4c676-25f8-4fbd-b500-b2c81bc91946`,
            uniqueUuid`ddc60d84-0505-4879-ae0c-8f1f09c0fd99`,
            uniqueUuid`1ae6ef07-32b4-4b54-ba8b-6905bab1947c`,
            uniqueUuid`470fd0eb-6a48-48a9-870f-1ffcd2a15d57`,
            uniqueUuid`c18b8257-bd69-45eb-8faa-ebf45f1b4a1f`,
            uniqueUuid`1ac7e866-e971-4cc8-90a6-ca0d5a79d0f2`,
            uniqueUuid`840c3714-2bff-4301-beab-04f7c1914a0a`,
            // dulux
            uniqueUuid`e2e65da7-073d-4dee-a573-0080f1da8fa3`,
            // amaron
            uniqueUuid`0ede12a9-dd64-4087-aa3e-adbc5a5a26f5`,
        ];
    }
    return null;
}

export function isOrganizationWithDashboard(workspaceId: Uuid, environment: string): boolean {
    const listOfOrganizationsWithDashboard = getListOfOrganizationsWithDashboard(environment);
    if (listOfOrganizationsWithDashboard === null) {
        return true;
    }
    return listOfOrganizationsWithDashboard.includes(workspaceId);
}

export function getListOfOrganizationsWithDashboardCustomDatefilter(environment: string): Uuid[] | null {
    if (environment.trim().toLocaleLowerCase() === "prod") {
        return [
            uniqueUuid`95f9667d-4398-4a88-9717-e365fd1218be`,
        ];
    }
    return null;
}

export function isOrganizationWithDashboardCustomDatefilter(workspaceId: Uuid, environment: string): boolean {
    const listOfOrganizationsWithDashboardCustomDatefilter = getListOfOrganizationsWithDashboardCustomDatefilter(environment);
    if (listOfOrganizationsWithDashboardCustomDatefilter === null) {
        return true;
    }
    return listOfOrganizationsWithDashboardCustomDatefilter.includes(workspaceId);
}
